import type { FeatureRoutes } from '@/app/screens'

/** The sales layer's screens (Phase 4), by their nav keys. */
export default {
  screens: {
    outlets: () => import('./OutletsPage.vue'),
    orders: () => import('./OrdersPage.vue'),
    catalog: () => import('./CatalogPage.vue'),
    territories: () => import('./TerritoriesPage.vue'),
    picklists: () => import('./PicklistsPage.vue'),
    fields: () => import('./FieldsPage.vue'),
    importExport: () => import('./ImportExportPage.vue'),
  },
} satisfies FeatureRoutes
